// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"53":"b7732f8a","894":"e86ef31d"}[chunkId] + ".chunk.css");